import { actions } from '../../constants/limits_constants.js';

const initialState = {
    limits: [],
    filter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
        modelFilter: {
            userName: ""
        },
        sortFilter: {}
    }
};

export default function reducer(state, action) {
    state = state || initialState;

    switch (action.type) {
        case actions.GET_ALL_LIMITS:
            {
                return {
                    ...state,
                    limits: action.limits.items,
                    filter: action.limits.filter
                };
            }
        default:
            return state;
    }
};

export const updateLimits = (limits) => ({type: actions.GET_ALL_LIMITS, limits});
